import styled, { css } from 'styled-components';

import { Color } from 'constants/enums';
import { setSvgColor, flexCenter } from 'styles/mixins';

import { IconButtonProps } from './types';

export const Button = styled.button<IconButtonProps>`
  width: 24px;
  height: 24px;

  border: none;
  outline: none;
  cursor: pointer;
  white-space: nowrap;

  ${flexCenter};
  background-color: transparent;

  ${({ theme, iconColor }) => css`
    ${setSvgColor(theme.colors[iconColor as Color].main)};

    &:hover:enabled {
      ${setSvgColor(theme.colors[iconColor as Color].hover)};
    }

    &:active:enabled {
      ${setSvgColor(theme.colors[iconColor as Color].active)};
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  `};
`;
